import React from 'react';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import './TopBanner.scss';

const TopBanner = () => {
  function handleRedClick() {
    window.open('https://ridiculouslyunfair.mercle.ai/', '_blank');
  }

  function handleBlueClick() {
    window.open('https://lessunfair.mercle.ai/', '_blank');
  }
  return (
    <Flexbox className='topbanner_wrapper'>
      <button className='topbanner_wrapper_redpill' onClick={handleRedClick}>
        Red Pill
      </button>
      <ThemedText.H6>Will you take the red pill or the blue pill?</ThemedText.H6>
      <button className='topbanner_wrapper_bluepill' onClick={handleBlueClick}>
        Blue Pill
      </button>
    </Flexbox>
  );
};

export default TopBanner;
